// Allen Institute WMB taxonomy, pinned by the 20250531 source manifest.
// Display metadata only: never infer taxonomy or change collection membership.
export const PALETTE_SOURCE = {"manifest_sha256":"12a58f42c06aff0a0cb8bdd7069b73273f64dbd144557d46a7a3242887f14478","manifest_version":"20250531","file":{"version":"20231215","relative_path":"metadata/WMB-taxonomy/20231215/cluster_annotation_term.csv","url":"https://allen-brain-cell-atlas.s3.us-west-2.amazonaws.com/metadata/WMB-taxonomy/20231215/cluster_annotation_term.csv","size":861405,"file_hash":"bf307de084140187706b8efd3378f015"},"sha256":"a14df2b81d9b557f53bc550e2e7143ed25f6fc2f2ebffd20071ae95bd04d6f76"};
export const ALLEN_COLORS = {
  "class": {
    "01 IT-ET Glut": "#FA0087",
    "02 NP-CT-L6b Glut": "#61e2a4",
    "03 OB-CR Glut": "#D00000",
    "04 DG-IMN Glut": "#16f2f2",
    "05 OB-IMN GABA": "#1b4332",
    "06 CTX-CGE GABA": "#CCFF33",
    "07 CTX-MGE GABA": "#f954ee",
    "08 CNU-MGE GABA": "#70E000",
    "09 CNU-LGE GABA": "#B199FF",
    "10 LSX GABA": "#3283FE",
    "11 CNU-HYa GABA": "#450099",
    "12 HY GABA": "#FF6600",
    "13 CNU-HYa Glut": "#90E0EF",
    "14 HY Glut": "#AA0DFE",
    "15 HY Gnrh1 Glut": "#F28266",
    "16 HY MM Glut": "#01d669",
    "17 MH-LH Glut": "#FAA307",
    "18 TH Glut": "#0D47A1",
    "19 MB Glut": "#007200",
    "20 MB GABA": "#9EF01A",
    "21 MB Dopa": "#38B000",
    "22 MB-HB Sero": "#EC4067",
    "23 P Glut": "#6b5ca5",
    "24 MY Glut": "#F0A0FF",
    "25 Pineal Glut": "#086375",
    "26 P GABA": "#72195a",
    "27 MY GABA": "#0096C7",
    "28 CB GABA": "#FFFB46",
    "29 CB Glut": "#9D0208",
    "30 Astro-Epen": "#594a26",
    "31 OPC-Oligo": "#03045E",
    "32 OEC": "#996B2E",
    "33 Vascular": "#858881",
    "34 Immune": "#825f45"
  },
  "subclass": {
    "001 CLA-EPd-CTX Car3 Glut": "#64c2fc",
    "002 IT EP-CLA Glut": "#1F665D",
    "003 L5/6 IT TPE-ENT Glut": "#C400FF",
    "004 L6 IT CTX Glut": "#C0FF4D",
    "005 L5 IT CTX Glut": "#660F38",
    "006 L4/5 IT CTX Glut": "#3DCCB7",
    "007 L2/3 IT CTX Glut": "#E9530F",
    "008 L2/3 IT ENT Glut": "#1F46CC",
    "009 L2/3 IT PIR-ENTl Glut": "#940099",
    "010 IT AON-TT-DP Glut": "#FF004B",
    "011 L2 IT ENT-po Glut": "#00FFC4",
    "012 MEA Slc17a7 Glut": "#456C99",
    "013 COAp Grxcr2 Glut": "#61CC5C",
    "014 LA-BLA-BMA-PA Glut": "#BBFF73",
    "015 ENTmv-PA-COAp Glut": "#B6CC7A",
    "016 CA1-ProS Glut": "#0F3466",
    "017 CA3 Glut": "#C973FF",
    "018 L2 IT PPP-APr Glut": "#0F6632",
    "019 L2/3 IT PPP Glut": "#925C99",
    "020 L2/3 IT RSP Glut": "#999145",
    "021 L4 RSP-ACA Glut": "#FFF226",
    "022 L5 ET CTX Glut": "#99A2FF",
    "023 SUB-ProS Glut": "#FF9999",
    "024 L5 PPP Glut": "#6B995C",
    "025 CA2-FC-IG Glut": "#FF7391",
    "026 NLOT Rho Glut": "#FFD573",
    "027 L6b EPd Glut": "#CC827A",
    "028 L6b/CT ENT Glut": "#CC0098",
    "029 L6b CTX Glut": "#9EFF99",
    "030 L6 CT CTX Glut": "#34661F",
    "031 CT SUB Glut": "#440066",
    "032 L5 NP CTX Glut": "#7B7ACC",
    "033 NP SUB Glut": "#99CAFF",
    "034 NP PPP Glut": "#B8FF26",
    "035 OB Eomes Ms4a15 Glut": "#7F1FCC",
    "036 HPF CR Glut": "#919900",
    "037 DG Glut": "#CC2400",
    "038 DG-PIR Ex IMN": "#3D53CC",
    "039 OB Meis2 Thsd7b Gaba": "#FF99F7",
    "040 OB Trdn Gaba": "#684599",
    "041 OB-in Frmd7 Gaba": "#FF0073",
    "042 OB-out Frmd7 Gaba": "#CC6D3D",
    "043 OB-mi Frmd7 Gaba": "#FF99A7",
    "044 OB Dopa-Gaba": "#96CC7A",
    "045 OB-STR-CTX Inh IMN": "#819945",
    "046 Vip Gaba": "#663D47",
    "047 Sncg Gaba": "#FFE999",
    "048 RHP-COA Ndnf Gaba": "#0003FF",
    "049 Lamp5 Gaba": "#FF764D",
    "050 Lamp5 Lhx6 Gaba": "#26FF3E",
    "051 Pvalb chandelier Gaba": "#2F992E",
    "052 Pvalb Gaba": "#661F3B",
    "053 Sst Gaba": "#99F2FF",
    "054 STR Prox1 Lhx6 Gaba": "#c60f3a",
    "055 STR Lhx8 Gaba": "#CC3DC9",
    "056 Sst Chodl Gaba": "#EDA32D",
    "057 NDB-SI-MA-STRv Lhx8 Gaba": "#199900",
    "058 PAL-STR Gaba-Chol": "#4DFFFA",
    "059 GPe-SI Sox6 Cyp26b1 Gaba": "#5CCC85",
    "060 OT D3 Folh1 Gaba": "#66580F",
    "061 STR D1 Gaba": "#005B66",
    "062 STR D2 Gaba": "#FF7800",
    "063 STR D1 Sema5a Gaba": "#663A2D",
    "064 STR-PAL Chst9 Gaba": "#967B09",
    "065 IA Mgp Gaba": "#00995F",
    "066 NDB-SI-ant Prdm12 Gaba": "#FF00D6",
    "067 LSX Sall3 Pax6 Gaba": "#006649",
    "068 LSX Otx2 Gaba": "#229917",
    "069 LSX Nkx2-1 Gaba": "#CCA43D",
    "070 LSX Prdm12 Slit2 Gaba": "#0067FF",
    "071 LSX Prdm12 Zeb2 Gaba": "#1F6625",
    "072 LSX Sall3 Lmo1 Gaba": "#00FFD0",
    "073 MEA-BST Sox6 Gaba": "#66360F",
    "074 MEA-BST Lhx6 Sp9 Gaba": "#FCFF4D",
    "075 MEA-BST Lhx6 Nr2e1 Gaba": "#995C70",
    "076 MEA-BST Lhx6 Nfib Gaba": "#990063",
    "077 CEA-BST Gal Avp Gaba": "#2E6637",
    "078 SI-MA-ACB Ebf1 Bnc2 Gaba": "#5CBCCC",
    "079 CEA-BST Six3 Cyp26b1 Gaba": "#73C1FF",
    "080 CEA-AAA-BST Six3 Sp9 Gaba": "#990091",
    "081 ACB-BST-FS D1 Gaba": "#FF4026",
    "082 CEA-BST Ebf1 Pdyn Gaba": "#CC885C",
    "083 CEA-BST Rai14 Pdyn Crh Gaba": "#CC5E5C",
    "084 BST-SI-AAA Six3 Slc22a3 Gaba": "#881FCC",
    "085 SI-MPO-LPO Lhx8 Gaba": "#26FFAD",
    "086 MPO-ADP Lhx8 Gaba": "#FF004F",
    "087 MPN-MPO-LPO Lhx6 Zfhx3 Gaba": "#26C2FF",
    "088 BST Tac2 Gaba": "#71FF4D",
    "089 PVR Six3 Sox3 Gaba": "#4DFFB4",
    "090 BST-MPN Six3 Nrgn Gaba": "#996600",
    "091 ARH-PVi Six6 Dopa-Gaba": "#6000FF",
    "092 TMv-PMv Tbx3 Hist-Gaba": "#2E664D",
    "093 RT-ZI Gnb3 Gaba": "#CCB65C",
    "094 SCH Six6 Cdc14a Gaba": "#FFBC4D",
    "095 DMH Prdm13 Gaba": "#179972",
    "096 PVHd Gsc Gaba": "#3B1FCC",
    "097 PVHd-SBPV Six3 Prox1 Gaba": "#2E3D66",
    "098 AHN-SBPV-PVHd Pdrm12 Gaba": "#BB7ACC",
    "099 SBPV-PVa Six6 Satb2 Gaba": "#99FF4D",
    "100 AHN Onecut3 Gaba": "#553D66",
    "101 ZI Pax6 Gaba": "#73FFCF",
    "102 DMH-LHA Gsx1 Gaba": "#992A00",
    "103 PVHd-DMH Lhx6 Gaba": "#73F8FF",
    "104 TU-ARH Otp Six6 Gaba": "#2E0F66",
    "105 TMd-DMH Foxd2 Gaba": "#3DCC9E",
    "106 PVpo-VMPO-MPN Hmx2 Gaba": "#3D4566",
    "107 DMH Hmx2 Gaba": "#FFB473",
    "108 ARH-PVp Tbx3 Gaba": "#CC3D76",
    "109 LGv-ZI Otx2 Gaba": "#664DFF",
    "110 BST-po Iigp1 Glut": "#973DCC",
    "111 TRS-BAC Sln Glut": "#500F66",
    "112 GPi Tbr1 Cngb3 Gaba-Glut": "#008ECC",
    "113 MEA-COA-BMA Ccdc42 Glut": "#660F5A",
    "114 COAa-PAA-MEA Barhl2 Glut": "#EDFF99",
    "115 MS-SF Bsx Glut": "#1F6641",
    "116 AVPV-MEPO-SFO Tbr1 Glut": "#1100CC",
    "117 LHA Barhl2 Glut": "#5C9995",
    "118 ADP-MPO Trp73 Glut": "#00CC6A",
    "119 SI-MA-LPO-LHA Skor1 Glut": "#352E66",
    "120 MEA Otp Foxp2 Glut": "#894599",
    "121 MEA-BST Otp Zic2 Glut": "#6100CC",
    "122 LHA-MEA Otp Glut": "#1FCCCA",
    "123 DMH Nkx2-4 Glut": "#FF73C8",
    "124 MPN-MPO-PVpo Hmx2 Glut": "#CC1F92",
    "125 DMH Hmx2 Glut": "#2F6600",
    "126 ARH-PVp Tbx3 Glut": "#CC4B1F",
    "127 DMH-LHA Vgll2 Glut": "#391799",
    "128 VMH Fezf1 Glut": "#00CBFF",
    "129 VMH Nr5a1 Glut": "#5CCCB1",
    "130 LHA Pmch Glut": "#B100CC",
    "131 LHA-AHN-PVH Otp Trh Glut": "#7ABACC",
    "132 AHN-RCH-LHA Otp Fezf1 Glut": "#2E9957",
    "133 PVH-SO-PVa Otp Glut": "#603DCC",
    "134 PH-ant-LHA Otp Bsx Glut": "#660010",
    "135 STN-PSTN Pitx2 Glut": "#CC0048",
    "136 PMv-TMv Pitx2 Glut": "#3D5566",
    "137 PH-an Pitx2 Glut": "#66441F",
    "138 PH Pitx2 Glut": "#5C6D99",
    "139 PH-LHA Foxb1 Glut": "#7C2E99",
    "140 PMd-LHA Foxb1 Glut": "#5C9965",
    "141 PH-SUM Foxa1 Glut": "#991793",
    "142 HY Gnrh1 Glut": "#7A9ACC",
    "143 MM-ant Foxb1 Glut": "#66662E",
    "144 MM Foxb1 Glut": "#FF2677",
    "145 MH Tac2 Glut": "#3D8ACC",
    "146 LH Pou4f1 Sox1 Glut": "#CC7A9D",
    "147 AD Serpinb7 Glut": "#FF7383",
    "148 AV Col27a1 Glut": "#16f2f2",
    "149 PVT-PT Ntrk1 Glut": "#5C8599",
    "150 CM-IAD-CL-PCN Sema5b Glut": "#076600",
    "151 TH Prkcd Grin2c Glut": "#68e497",
    "152 RE-Xi Nox4 Glut": "#663D57",
    "153 MG-POL-SGN Nts Glut": "#992E38",
    "154 PF Fzd5 Glut": "#1C0099",
    "155 PRC-PAG Pax6 Glut": "#3D6566",
    "156 MB-ant-ve Dmrta2 Glut": "#99862E",
    "157 RN Spp1 Glut": "#FF514D",
    "158 MRN-PAG Nkx6-1 Glut": "#B6FF4D",
    "159 IF-RL-CLI-PAG Foxa1 Glut": "#63FF26",
    "160 PAG-SC Neurod2 Meis2 Glut": "#2E7799",
    "161 PAG Pou4f3 Glut": "#CC3DA3",
    "162 CUN Evx2 Lhx2 Glut": "#CCC27A",
    "163 APN C1ql2 Glut": "#5C64CC",
    "164 APN C1ql4 Glut": "#1FCC4D",
    "165 PAG-MRN Pou3f1 Glut": "#FF9D26",
    "166 MRN Pou3f1 C1ql4 Glut": "#005C99",
    "167 PRC-PAG Tcf7l2 Irx2 Glut": "#889917",
    "168 SPA-SPFm-SPFp-POL-PIL-PoT Sp9 Glut": "#26FFFE",
    "169 PAG-SC Pou4f1 Zic1 Glut": "#311FCC",
    "170 PAG-MRN Tfap2b Glut": "#82995C",
    "171 PAG Pou4f1 Bnc2 Glut": "#997045",
    "172 PAG Pou4f1 Ebf2 Glut": "#F2FF73",
    "173 PAG Pou4f2 Glut": "#990027",
    "174 PAG Pou4f2 Mesi2 Glut": "#5FCC5C",
    "175 SC Bnc2 Glut": "#CC3D9D",
    "176 SCig Foxb1 Glut": "#47FF26",
    "177 SCig-an-PPT Foxb1 Glut": "#453D66",
    "178 SCig Foxb1 Otx2 Glut": "#5C73CC",
    "179 SCdg-PAG Tfap2b Glut": "#7ACCBE",
    "180 SCiw Pitx2 Glut": "#50662E",
    "181 IC Tfap2d Maf Glut": "#6C1799",
    "182 CUN-PPN Evx2 Meis2 Glut": "#CC7A7E",
    "183 PBG Mtnr1a Glut-Chol": "#00CC7F",
    "184 PAG Tcf24 Glut": "#ED0000",
    "185 SCig Tfap2b Chrnb3 Glut": "#002099",
    "186 SCop Pou4f2 Neurod2 Glut": "#FF73FF",
    "187 SCsg Pde5a Glut": "#B899FF",
    "188 SCop Sln Glut": "#73FF98",
    "189 PAG Ucn Glut": "#009923",
    "190 ND-INC Foxd2 Glut": "#997817",
    "191 PAG-MRN Rln3 Gaba": "#CC7400",
    "192 PPN-CUN-PCG Otp En1 Gaba": "#DF99FF",
    "193 MRN-PPN-CUN Pax8 Gaba": "#3DCC66",
    "194 MRN-VTN-PPN Pax5 Cdh23 Gaba": "#82CC1F",
    "195 SNr-VTA Pax5 Npas1 Gaba": "#2E8799",
    "196 PAG-PPN Pax5 Sox21 Gaba": "#1D0066",
    "197 SNr Six3 Gaba": "#7A5C99",
    "198 IC Six3 En2 Gaba": "#C2FF26",
    "199 PAG-MRN-RN Foxa2 Gaba": "#ab1dd6",
    "200 PAG-ND-PCG Onecut1 Gaba": "#000799",
    "201 PAG-RN Nkx2-2 Otx1 Gaba": "#7DFF4D",
    "202 PRT Tcf7l2 Gaba": "#474599",
    "203 LGv-SPFp-SPFm Nkx2-2 Tcf7l2 Gaba": "#FFC199",
    "204 SC Otx2 Gcnt4 Gaba": "#99685C",
    "205 SC-PAG Lef1 Emx2 Gaba": "#4D79FF",
    "206 SCm-PAG Cdh23 Gaba": "#CC5C69",
    "207 SCs Dmbx1 Gaba": "#4CCC3D",
    "208 SC Lef1 Otx2 Gaba": "#994F45",
    "209 SCs Pax7 Nfia Gaba": "#CC1F66",
    "210 PRT Mecom Gaba": "#CC6B3D",
    "211 SC Tnnt1 Gli3 Gaba": "#76CC5C",
    "212 SCs Lef1 Gli3 Gaba": "#FFA300",
    "213 SCsg Gabrr2 Gaba": "#0e0163",
    "214 IPN Otp Crisp1 Gaba": "#BCCC3D",
    "215 SNc-VTA-RAmb Foxa1 Dopa": "#992E62",
    "216 MB-MY Tph2 Glut-Sero": "#99FFE4",
    "217 PB Lmx1a Glut": "#0F5666",
    "218 PSV Lmx1a Trpv6 Glut": "#fc003f",
    "219 PB-SUT Tlx3 Lhx2 Glut": "#4B2E66",
    "220 PB Pax5 Glut": "#84FF73",
    "221 LDT-PCG Vsx2 Lhx4 Glut": "#FF4DC7",
    "222 PB Evx2 Glut": "#1F8ACC",
    "223 B-PB Nr4a2 Glut": "#4ff7de",
    "224 PCG-PRNr Vsx2 Nkx6-1 Glut": "#175B99",
    "225 PRNc-NI-SG-RPO Vsx2 Nr4a2 Glut": "#559917",
    "226 PRNc-PARN Tlx1 Glut": "#8C5CCC",
    "227 PB-PSV Phox2b Glut": "#44FF26",
    "228 PSV Pvalb Lhx2 Glut": "#3A662E",
    "229 PB-NTS Phox2b Ebf3 Lmx1b Glut": "#AB5CCC",
    "230 PRNr Otp Nfib Glut": "#3ECC1F",
    "231 IPN-LDT Vsx2 Nkx6-1 Glut": "#994546",
    "232 LDT Vsx2 Nkx6-1 Nfib Glut": "#45994B",
    "233 NLL-SOC Spp1 Glut": "#CCFF4D",
    "234 MEV Ppp1r1c Glut": "#0F6610",
    "235 PG-TRN-LRN Fat2 Glut": "#9B7ACC",
    "236 IRN Vip Glut": "#66593D",
    "237 PRP-NI-PRNc-GRN Otp Glut": "#FF6426",
    "238 NTS Phox2b Glut": "#7ACC9F",
    "239 MARN-GRN Pyy Glut": "#458499",
    "240 MDRNv Lhx4 Qrfprl Glut": "#c10717",
    "241 NTS Mbnl3 Glut": "#e925ed",
    "242 PGRNd Dmbx1 Glut": "#996E45",
    "243 PGRN-PARN-MDRN Hoxb5 Glut": "#C6FF99",
    "244 MV-SPIV Slc6a2 Glut": "#99985C",
    "245 SPVI-SPVC Tlx3 Ebf3 Glut": "#84CC3D",
    "246 CU-ECU-SPVI Foxb1 Glut": "#5A1F66",
    "247 MV-SPIV Phox2b Ebf3 Lbx1 Glut": "#3DC2CC",
    "248 MV-SPIV Zic4 Neurod2 Glut": "#85CC00",
    "249 NTS Aldh1a2 Glut": "#f22693",
    "250 CBN Neurod2 Pvalb Glut": "#26FF93",
    "251 NTS Dbh Glut": "#221F66",
    "252 DMX VII Tbx20 Chol": "#566600",
    "253 IO Fgl2 Glut": "#99322E",
    "254 VCO Mafa Meis2 Glut": "#00CC7C",
    "255 SPVO Mafa Meis2 Glut": "#CC8E1F",
    "256 SPVC Mafa Glut": "#805CCC",
    "257 SPVC Ccdc172 Glut": "#580099",
    "258 SPVC Nmu Glut": "#99805C",
    "259 MDRNd Bves Glut": "#fc235d",
    "260 MDRNv Crp Glut": "#1FCC43",
    "261 HB Calcb Chol": "#EAFF4D",
    "262 Pineal Crx Glut": "#0F6654",
    "263 CS-RPO Meis2 Gaba": "#B6CC5C",
    "264 PRNc Otp Gly-Gaba": "#4DFFCD",
    "265 PB Sst Gly-Gaba": "#F44D00",
    "266 PRNc Prox1 Brs3 Gly-Gaba": "#58992E",
    "267 CS-PRNr-PCG Tmem163 Otp Gaba": "#3D6647",
    "268 CS-PRNr-DR En1 Sox2 Gaba": "#1F5366",
    "269 LDT Fgf7 Gaba": "#00CCBA",
    "270 LDT-DTN Gata3 Nfix Gaba": "#aae6ed",
    "271 NI-RPO Gata3 Nr4a2 Gaba": "#00CC4A",
    "272 LDT-PCG-CS Gata3 Lhx1 Gaba": "#630099",
    "273 PDTg-PCG Pax6 Gaba": "#991761",
    "274 PDTg Otp Shroom3 Gaba": "#5BFF00",
    "275 PDTg Otp Olig3 Gaba": "#0F1266",
    "276 LDT-PCG St18 Gaba": "#456499",
    "277 DTN-LDT-IPN Otp Pax3 Gaba": "#1F3766",
    "278 NLL Gata3 Gly-Gaba": "#E57300",
    "279 PSV Pax2 Gly-Gaba": "#d2b8f2",
    "280 NLL-po Pax7 Gaba": "#000999",
    "281 POR Gata3 Gly-Gaba": "#00CC1B",
    "282 POR Spp1 Gly-Gaba": "#35CC00",
    "283 PRP Otp Gly-Gaba": "#995C2E",
    "284 GRN-IRN-MDRNd Ikzf1 Gly-Gaba": "#659900",
    "285 MY Lhx1 Gly-Gaba": "#f20985",
    "286 PPY-PGRNl Vip Glyc-Gaba": "#CC5C81",
    "287 MV-SPIV-PRP Dmbx1 Gly-Gaba": "#4DBEFF",
    "288 MDRN Hoxb5 Ebf2 Gly-Gaba": "#660038",
    "289 MDRNd Prox1 Pax6 Gly-Gaba": "#4e5b48",
    "290 MY Prox1 Lmo7 Gly-Gaba": "#6ff754",
    "291 NTS-MDRNd Prox1 Zic1 Gly-Gaba": "#990004",
    "292 MV Nkx6-1 Gly-Gaba": "#CC3D91",
    "293 PAS-MV Ebf2 Gly-Gaba": "#2E3399",
    "294 MV Pax6 Gly-Gaba": "#66502E",
    "295 CBN Dmbx1 Gaba": "#00FF6C",
    "296 RPA Pax6 Hoxb5 Gly-Gaba": "#3426FF",
    "297 CU-ECU Pax2 Gly-Gaba": "#2E6799",
    "298 PRP Gata3 Slc6a5 Gly-Gaba": "#00FF08",
    "299 MARN-PPY Ngfr Gly-Gaba": "#CC8A5C",
    "300 PARN-MDRNd-NTS Gbx2 Gly-Gaba": "#CC3D70",
    "301 MV Nr4a2 Gly-Gaba": "#efda4f",
    "302 MV Xdh Gly-Gaba": "#72FF00",
    "303 IRN Dmbx1 Pax2 Gly-Gaba": "#5C997D",
    "304 NTS-PARN Neurod2 Gly-Gaba": "#FF1400",
    "305 SPVI-SPVC Sall3 Nfib Gly-Gaba": "#66140F",
    "306 SPVI-SPVC Sall3 Lhx1 Gly-Gaba": "#FF73EA",
    "307 RO-RPA Pkd2l1 Gaba": "#26FFE8",
    "308 DCO Il22 Gly-Gaba": "#994517",
    "309 CB PLI Gly-Gaba": "#009899",
    "310 CBX Golgi Gly-Gaba": "#003366",
    "311 CBX MLI Megf11 Gaba": "#8BCC5C",
    "312 CBX MLI Cdh22 Gaba": "#45996C",
    "313 CBX Purkinje Gaba": "#511799",
    "314 CB Granule Glut": "#FF4826",
    "315 DCO UBC Glut": "#1FCC87",
    "316 Bergmann NN": "#8E2600",
    "317 Astro-CB NN": "#CC4E00",
    "318 Astro-NT NN": "#AD5CCC",
    "319 Astro-TE NN": "#3DCCB1",
    "320 Astro-OLF NN": "#FF73CF",
    "321 Astroependymal NN": "#0833ce",
    "322 Tanycyte NN": "#FF26A1",
    "323 Ependymal NN": "#D8FF00",
    "324 Hypendymal NN": "#3F2E99",
    "325 CHOR NN": "#2D9917",
    "326 OPC NN": "#FF26CB",
    "327 Oligo NN": "#99FFBC",
    "328 OEC NN": "#FF99CF",
    "329 ABC NN": "#CC5CC1",
    "330 VLMC NN": "#653D66",
    "331 Peri NN": "#82992E",
    "332 SMC NN": "#FF9F73",
    "333 Endo NN": "#994567",
    "334 Microglia NN": "#CC1F4E",
    "335 BAM NN": "#66493D",
    "336 Monocytes NN": "#A673FF",
    "337 DC NN": "#CCA27A",
    "338 Lymphoid NN": "#3D5766"
  }
};

// Bind this supplement to the exact imported scientific snapshot, not similar names.
export function collectionTaxonomyColors(collection, taxonomy = {}) {
  if (collection?.source_release_id !== 'allen-merfish-c57bl6j-638850:20250531'
      || collection?.content_sha256 !== '89400c6dc54065e8844c6f3f1451069e1d8c5c27d903378b0335c6168e970507'
      || collection?.cell_ids_sha256 !== '7fb174623b19d7f94a61b819ccce700aebb8f6ccb9dc4d3d075195b479484255') return taxonomy;
  return Object.fromEntries(Object.entries(taxonomy).map(([level, items]) => [level,
    items.map(item => ({...item, color: /^#[0-9a-f]{6}$/i.test(item.color || '')
      ? item.color : ALLEN_COLORS[level]?.[item.id] || null}))
  ]));
}
